import { sceneItems } from '@/mocks/scenes';
import SectionHeading from './SectionHeading';

export default function ScenesSection() {
  return (
    <section id="scenes" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1180px] px-4 md:px-6">
        <SectionHeading
          eyebrow="05 / 经典片段"
          title="值得留意的五个关键片段"
          desc="影片的看点集中在几个情绪转折清晰的段落。以下按剧情顺序整理出五个经典片段，方便你观影时对照留意（配图为氛围示意图）。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {sceneItems.map((scene, index) => (
            <article
              key={scene.no}
              className={`flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 ${
                index === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className={`w-full ${index === 0 ? 'h-56 md:h-72' : 'h-48 md:h-52'}`}>
                <img src={scene.image} alt={`${scene.title}——${scene.desc.slice(0, 24)}`} className="h-full w-full object-cover object-top" />
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <div className="flex items-center gap-3">
                  <span className="font-heading text-lg font-bold text-primary-500">{scene.no}</span>
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-xs text-secondary-900">
                    {scene.tag}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950 md:text-lg">{scene.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{scene.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}